<template>
  <div class="NotFound">
    <h1>404 Route Not Found</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>